import React, { useState } from 'react';

// Small circular badge reusing the .comic-avatar ink-circle treatment. Shows
// the Hero's uploaded photo when present (falls back to the plain letter
// badge on load failure, e.g. a stale/deleted Storage URL), otherwise the
// letter badge -- same silhouette either way so switching between Heroes
// with/without a photo doesn't shift layout. Extracted out of
// ProfileSwitcher.jsx so ActiveSessionsBar.jsx can reuse the identical
// avatar treatment instead of duplicating it.
const InitialAvatar = ({ name, photoURL, size = 34 }) => {
  const [imgFailed, setImgFailed] = useState(false);
  const showPhoto = photoURL && !imgFailed;

  return (
    <div
      className="comic-avatar"
      style={{ width: size, height: size, border: "2px solid #232526" }}
    >
      {showPhoto ? (
        <img
          src={photoURL}
          alt={name}
          className="comic-avatar__img"
          onError={() => setImgFailed(true)}
        />
      ) : (
        <span
          style={{
            fontFamily: "'Shadows Into Light Two', 'Shadows Into Light 2', cursive",
            color: "#f3d8ac",
            fontSize: size * 0.5,
            lineHeight: 1
          }}
        >
          {(name || "?").charAt(0).toUpperCase()}
        </span>
      )}
    </div>
  );
};

export default InitialAvatar;
